import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/SidebarNav.css';

const SidebarNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

    const handleBrochureDownload = async () => {
    try {
      const response = await fetch('/assets/brochure/Empowering-Your-Future-with-Sustainable-Energy-Solution_TM.pdf');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'V-Square-Renewables-Brochure.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading brochure:', error);
      // Fallback: open in new tab if download fails
      window.open('/assets/brochure/Empowering-Your-Future-with-Sustainable-Energy-Solution_TM.pdf', '_blank');
    }
  };

  return (
    <>
      {/* Toggle Button */}
      <button 
        className={`sidebar-toggle ${isOpen ? 'open' : ''}`}
        onClick={toggleSidebar}
        aria-label="Toggle navigation"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h3>V SQUARE RENEWABLES</h3>
          <button className="sidebar-close" onClick={toggleSidebar}>
            ×
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul>
            <li>
              <Link to="/" onClick={toggleSidebar}>
                <span className="nav-icon">🏠</span>
                Home
              </Link>
            </li>
            <li>
              <Link to="/services" onClick={toggleSidebar}>
                <span className="nav-icon">⚡</span>
                Services
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={toggleSidebar}>
                <span className="nav-icon">👥</span>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={toggleSidebar}>
                <span className="nav-icon">📞</span>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/government-schemes" onClick={toggleSidebar}>
                <span className="nav-icon">🏛️</span>
                Govt. Schemes
              </Link>
            </li>
            <li>
              <Link to="/news" onClick={toggleSidebar}>
                <span className="nav-icon">📰</span>
                News & Updates
              </Link>
            </li>
             <li>
              <Link to="/solar-calculator" onClick={toggleSidebar}>
                <span className="nav-icon">🧮</span>
                Solar Calculator
              </Link>
            </li>
            <button
            className="download-brochure-btn"
            onClick={handleBrochureDownload}
            title="Download our brochure"
            style={{ margin: "20px" }}  
          >
          Download Brochure
          </button>
          </ul>
        </nav>

        <div className="sidebar-footer">
          <div className="contact-info">
            <p><strong>Phone:</strong> +91 8830955580</p>
            <p><strong>Email:</strong> info@vsquarerenewables.com</p>
             <p><strong>Address:</strong> S.N.102, Charholi Phata, Pune, Maharashtra 412105</p>
          </div>
          <div className="social-links">
            <a href="https://www.linkedin.com/company/v-square-renewables" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="black" d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5ZM0.22 23.5h4.56V7.98H0.22V23.5ZM8.02 7.98H12.4v2.12h0.06c0.61-1.16 2.11-2.38 4.35-2.38 4.65 0 5.51 3.06 5.51 7.04v8.74h-4.56v-7.74c0-1.85-0.04-4.24-2.58-4.24-2.58 0-2.97 2.02-2.97 4.11v7.87H8.02V7.98Z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/share/1Q7R1N1a6f/" aria-label="Facebook">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="black" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-2.51 0-3.028 1.254-3.028 2.46v2.953h3.028l-.488 3.47h-2.54v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/vsquarerenewables" aria-label="Instagram">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="black" d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9A5.5 5.5 0 0 1 16.5 22h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2Zm9 2h-9A3.5 3.5 0 0 0 4 7.5v9A3.5 3.5 0 0 0 7.5 20h9a3.5 3.5 0 0 0 3.5-3.5v-9A3.5 3.5 0 0 0 16.5 4Zm-4.5 3.2A4.8 4.8 0 1 1 7.2 12 4.8 4.8 0 0 1 12 7.2Zm0 2A2.8 2.8 0 1 0 14.8 12 2.8 2.8 0 0 0 12 9.2ZM17.6 6.7a1.1 1.1 0 1 1-1.1 1.1 1.1 1.1 0 0 1 1.1-1.1Z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
    </>
  );
};

export default SidebarNav;
